import { IconButton } from "@mui/joy";

export default function BackButton({
  onBack,
  disabled,
  iconColor,
}: {
  onBack?: () => void;
  disabled?: boolean;
  iconColor?: string;
}) {
  return (
    <IconButton
      onClick={onBack}
      disabled={disabled}
      variant="plain"
      color="neutral"
      // size prop은 수동으로 크기를 지정하므로 제거하거나 그대로 두어도 됩니다.
      sx={{
        // 1. 버튼(컨테이너)의 크기를 36x36으로 고정합니다.
        width: 36,
        height: 36,

        // 2. IconButton의 기본 패딩을 제거합니다.
        padding: 0,

        // 3. Flexbox를 사용하여 내부 아이콘(자식 요소)을 중앙 정렬합니다.
        display: "flex",
        alignItems: "center", // 수직 중앙 정렬
        justifyContent: "center", // 수평 중앙 정렬

        // 기존의 호버 및 액티브 효과는 그대로 유지합니다.
        "&:hover": { backgroundColor: "transparent" },
        "&:active": { backgroundColor: "transparent" },
      }}
    >
      {/* 
        이 24x24 SVG 아이콘은 이제 36x36 부모 요소의 정중앙에 위치하게 됩니다.
        아이콘 자체의 비대칭 문제는 여전히 존재하므로, 
        이전 답변에서 제안한 중앙 정렬된 아이콘을 사용하는 것이 좋습니다.
      */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* 아이콘이 시각적으로 중앙에 보이도록 path를 수정하거나 transform을 적용하는 것이 좋습니다. */}
        <g transform="translate(3.25, 0)">
          <path
            d="M12 5.5L5.5 12L12 18.5"
            stroke={disabled ? "#AFB6BA" : (iconColor || "#20272B")}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </IconButton>
  );
}
